import { render, staticRenderFns } from "./MiniGameList.vue?vue&type=template&id=457d747a&"
import script from "./MiniGameList.vue?vue&type=script&lang=js&"
export * from "./MiniGameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports